/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelection
 */

import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options'
import Keyboard from 'styleguide/modules/keyboard';
import addToBag from '../pdp/add-to-bag';

export const PLUGIN_NAME = 'sizeSelection';
export const SS_MENU_CLASS = '.js-select-size-menu';
export const SS_TRIGGER_CLASS = '.js-select-size-trigger';
export const SS_ATB_CLASS = '.js-btn-atb';
export const SS_PARENT_CONTAINER_CLASS = '.js-plp-product';

export const DEFAULTS = {
    animationSpeed: 100,
};

/**
 * Prevent Hash
 * @param  {event} interaction event
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 */
 const preventHash = (evt, $saveSizeTrigger) => {
    if(Keyboard.parseKey(evt) === 'ENTER' || evt.type == 'click') {
      if($saveSizeTrigger.attr('href') == "#") {
        evt.preventDefault();
      }
    }
  };

const setLoading = ($el) => {
    $el.closest('.js-product-info-block').append(progressBarHTML());
}
const removeLoading = ($el) => {
    $el.closest('.js-product-info-block').find('.plp__size-loading').remove();
}

const progressBarHTML = () => {
    return `<div class="plp__size-loading">
        <div class="u-padding-a--xl">
                <div class="progress-bar progress-bar--dark">
                    <div class="u-screen-reader">
                        Content is Loading
                    </div>
                </div>
            </div>
        </div>`
  }

const openSizes = ($el, $saveSizeTrigger, $saveSizeMenu, opts) => {
    $el.addClass('ss-is-open');
    $saveSizeMenu.css({display:'block', opacity:0, visibility: 'visible'}).stop().animate({
        opacity: 1,
      }, opts.animateSpeed, () => {
      });
    setClickCloseListener($el, $saveSizeTrigger, $saveSizeMenu, opts);
}

const closeSizes = ($el, $saveSizeMenu, opts) => {
    $el.removeClass('ss-is-open');
    $el.find('.js-select-size-menu').remove();
    $el.find('input[type=radio][name=fav-size-selection]').off('change.size');
    $(document).off('click.close');
    $saveSizeMenu.stop().animate({
        opacity: 0,
      }, opts.animateSpeed / 2, () => {
        $saveSizeMenu.css('display', 'none', 'visibility', 'hidden');
      });
}

const showConfirmation = ($saveSizeTrigger, opts, hasError) => {
    const {saveSizeConfirmPath} = opts;
    if (saveSizeConfirmPath) {
        $.modal({
            url: `${saveSizeConfirmPath}`,
            type: 'notification',
            triggerOpen: true,
            returnFocus: $saveSizeTrigger,
        })
    }
}

const updateSizeCopy = ($saveSizeTrigger, sizeValue, $parentContainer, opts, preorder) => {
    const {code} = opts;
    if (!opts.noCopyUpdate) {
        $saveSizeTrigger.html(`<span id="${code}-fav-size-value" data-size="${sizeValue}">Size: ${sizeValue}</span>`);
    }

    if ($parentContainer) {
        const $addToBag = $parentContainer.find(SS_ATB_CLASS);
        $addToBag.data("size", sizeValue);
        $addToBag.data("oos", false);
        if (preorder) {
            $addToBag.html("PreOrder");
        } else {
            $addToBag.html("add to bag");
        }
    }
}

/**
 * Focus trap utility for size menu popover
 */
const trapModalFocus = ($menu) => {
    const radios = $menu.find('input[type=radio]:not([disabled])').filter(':visible');
    const first = radios[0];
    const last = radios[radios.length - 1];

    $menu.find('.js-focus-start').on('focus', () => {
        if (last) last.focus();
    });

    $menu.find('.js-focus-end').on('focus', () => {
        if (first) first.focus();
    });
};

const keydownHandler = ($el, evt, $saveSizeTrigger, $parentContainer, opts, isKey) => {
    const key = Keyboard.parseKey(evt);
    const isEnter = key === 'ENTER';
    const isNextArrows = key === 'ARROWRIGHT' || key === 'ARROWDOWN';
    const isPrevArrows = key === 'ARROWLEFT' || key === 'ARROWUP';
    const isEscape = key === 'ESCAPE';
    const sizeHaveFocus = $el.find('input[type=radio]').is(":focus");

    const $saveSizeMenu = $el.find('.js-select-size-menu');

    // ENTER: open or select size
    if (isEnter) {
        if (!$el.hasClass('ss-is-open')) {
            evt.preventDefault();
            getSizes($el, $saveSizeTrigger, $parentContainer, opts, isKey);
            return;
        }

        if (sizeHaveFocus) {
            const $target = $(evt.target);
            const sizeIsChecked = $target.is(':checked');
            const sizeValue = $target.prop('value');
            const preorder = $target.data('preorder');

            if (!sizeIsChecked) {
                updateSizeCopy($saveSizeTrigger, sizeValue, $parentContainer, opts, preorder);
            }

            updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue);
        }
    }

    // Arrow key navigation
    if ((isNextArrows || isPrevArrows) && sizeHaveFocus) {
        setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, $parentContainer, isKey, opts);
    }

    // ESCAPE: close the modal
    if (isEscape) {
        closeSizes($el, $saveSizeMenu, opts);
        return;
    }
};


const setUpdateSizeListener = ($el, $saveSizeTrigger, $saveSizeMenu, $parentContainer, isKey, opts) => {

    $el.find('input[type=radio]').on('change.size', function(evt) {
        const sizeValue = $(this).prop('value');
        const preorder = $(this).data("preorder");
        updateSizeCopy($saveSizeTrigger, sizeValue, $parentContainer, opts, preorder);
        const atb = opts.addToBag;

        if(!isKey) {
            updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue, atb);
        }
        if (atb === 'true' || atb === true) {
            const $addToBag = $parentContainer.find(SS_ATB_CLASS);
            if ($addToBag.length) {
                $addToBag.click();
            } else {
                addItemToBag(opts.code, sizeValue);
            }
        }
    })
}

const updateSizeToDb = ($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue, atb) => {
    if (sizeValue) {
        const {updateSizePath, code} = opts;
        setLoading($el);
        removeLoading($el);
        closeSizes($el, $saveSizeMenu, opts);
        $('.js-select-size-menu').remove();
        if (updateSizePath) {
            $.ajax({
                url: `${updateSizePath}${sizeValue}`,
                type: "POST",
                success: function (success) {
                    removeLoading($el);
                    if (success) {
                        closeSizes($el, $saveSizeMenu, opts);
                        if (atb !== 'true') {
                            showConfirmation($saveSizeTrigger, opts, false);
                        }
                        if (typeof logEngagementWithDetails === "function") {
                            logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', `size=${sizeValue}, code=${code}`);
                        }
                    }
                }
            });
        }
    } else {
        closeSizes($el, $saveSizeMenu, opts);
        showConfirmation($saveSizeTrigger, opts, true);
    }
}

const setClickCloseListener = ($el, $saveSizeTrigger, $saveSizeMenu, opts) => {
    $(document).on('click.close',function(evt) {
        const $sizeMenu = $el.find('.js-select-size-menu');
        const notSizeMenu = !$sizeMenu.is(evt.target);
        const notSizeOption = $sizeMenu.has(evt.target).length === 0;
        const notTriggerBtn = evt.target !== $saveSizeTrigger[0];
        if (notSizeMenu && notSizeOption && notTriggerBtn) {
            closeSizes($el, $saveSizeMenu, opts);
        }
    })
}


const getSizes = ($el, $saveSizeTrigger, $parentContainer, opts, isKey) => {
    const {sizePath} = opts;
    opts.addToBag = $saveSizeTrigger.data('addToBag');
    $saveSizeTrigger.data('addToBag', 'false');
    setLoading($el);
    $.ajax({
        url: `${sizePath}`,
        type: "GET",
        success: function (sizePopupMarkup) {
            removeLoading($el);
            $saveSizeTrigger.after(sizePopupMarkup);
            const $saveSizeMenu = $el.find(SS_MENU_CLASS);
            openSizes($el, $saveSizeTrigger, $saveSizeMenu, opts);
            trapModalFocus($saveSizeMenu);
            if(!isKey) {
                setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, $parentContainer, isKey, opts);
            }
        }
    });
}


/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, $saveSizeTrigger, $parentContainer, opts) => {
    
    $el
    .on('keydown',(evt) => {
        keydownHandler($el, evt, $saveSizeTrigger, $parentContainer, opts, true);
    });
    $saveSizeTrigger.on('click', (evt) => {
        evt.preventDefault();
        if (opts.oneSize && opts.addToBag) {
            addItemToBag(opts.code, 'all');
        } else {
            getSizes($el, $saveSizeTrigger, $parentContainer, opts, false);
        }
    });
    // $saveSizeTrigger.on('keydown', (evt) => {
    //     preventHash(evt, $saveSizeTrigger);
    // });
};

const addItemToBag = function(code, size) {
    if (window.rcProps.plp) {
        window.rcProps.pdp = window.rcProps.pdp || {};
        window.rcProps.pdp.sectionURL = window.rcProps.plp.sectionurl;
        window.rcProps.pdp.sessionID = window.rcProps.plp.sessionId;
    }

    addToBag(code, size);
};

/**
 * Initializes sizeSelection.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
export default function sizeSelection(el, options = {}) {
    const $el = $(el);
    const opts = mergeOptions(DEFAULTS, options, $el);
    const $saveSizeTrigger = $el.find(SS_TRIGGER_CLASS);
    const $parentContainer = $el.closest(SS_PARENT_CONTAINER_CLASS);
    setEventListeners($el, $saveSizeTrigger, $parentContainer, opts);
}

registerJQueryPlugin(PLUGIN_NAME, sizeSelection);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/size-selection.js